import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  const highlights = [
    { icon: 'User', text: 'Direct access to the lead advisor' },
    { icon: 'Zap', text: 'Fast, decisive communication' },
    { icon: 'Shield', text: 'Backed by a trusted private network' },
  ];

  return (
    <section id="about" className="py-24 md:py-32 bg-brand-gray">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="grid lg:grid-cols-2 gap-20 items-center"
        >
          <div>
            <div className="inline-block px-4 py-1.5 bg-brand-gold/10 text-brand-gold text-xs font-bold tracking-widest uppercase mb-6 rounded-full">
              The Firm
            </div>
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight leading-tight mb-8 text-brand-black">
              Focused, independent advisory for the modern deal-maker.
            </h2>
            <p className="text-xl text-brand-muted font-light leading-relaxed mb-8">
              White Knight Global Consulting delivers clear, strategic direction in high-stakes M&A situations. We bypass the friction of traditional large-scale firms to provide direct, high-impact results.
            </p>
            <p className="text-brand-muted font-light leading-relaxed">
              Our approach is rooted in absolute discretion and swift execution, ensuring that our clients maintain their competitive advantage throughout every phase of the transaction lifecycle.
            </p>
          </div>

          <div className="space-y-6">
            {highlights.map((item, index) => (
              <motion.div 
                key={index}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex items-center gap-6 p-8 bg-white border border-brand-border hover:border-brand-gold transition-colors group"
              >
                <span className="flex-shrink-0 w-14 h-14 rounded-full bg-brand-black text-brand-white flex items-center justify-center group-hover:bg-brand-gold transition-colors">
                  <SafeIcon name={item.icon} className="text-2xl" />
                </span>
                <span className="text-xl font-bold text-brand-black">{item.text}</span>
              </motion.div>
            ))}
            <p className="mt-8 text-sm text-brand-muted italic flex items-center gap-2">
              <SafeIcon name="Lock" className="text-brand-gold" />
              Operates with complete discretion. Professional anonymity maintained.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default About;